const prefix = 'FLIGHT_OVERVIEW';
export const createActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD'`,
    LOADING: `${prefix}/${resource}/LOADING'`,
    LOADED: `${prefix}/${resource}/LOADED'`,
});
export const loadOverviewActionTypes = createActionTypes('LOAD_FLIGHT_OVERVIEW');
// Action Creators
export const loadOverview = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadOverviewActionTypes.LOAD,
        payload: {
            flightId: flightId,
            workspaceId: workspaceId,
            managementGroup: managementGroup,
        },
    };
};
export const loadingOverview = (payload) => {
    return {
        type: loadOverviewActionTypes.LOADING,
        payload: {
            flightId: payload.flightId,
            workspaceId: payload.workspaceId,
            managementGroup: payload.managementGroup,
        },
    };
};
export const loadedOverview = (payload, result) => {
    return {
        type: loadOverviewActionTypes.LOADED,
        payload: {
            flightId: payload.flightId,
            workspaceId: payload.workspaceId,
            managementGroup: payload.managementGroup,
            result: result,
        },
    };
};

//# sourceMappingURL=FlightOverview.ducks.js.map
